import { Nullable } from '@utils/util.types';
import classNames from 'classnames';

interface RoleCardProps {
	role: string;
	title: string;
	description?: string;
	selectedRole: Nullable<string>;
	className?: string;
	isDisabled?: boolean;
	onSelect: (role: string) => void;
}

export const RoleCard = ({
	role,
	title,
	description,
	selectedRole,
	onSelect,
	isDisabled,
	className,
}: RoleCardProps) => {
	const isSelected = selectedRole === role;

	return (
		<div className="flex w-full">
			<button
				disabled={isDisabled}
				type="button"
				onClick={() => onSelect(role)}
				className={classNames(
					'relative border-[1px] rounded-lg p-2 text-center w-40 h-36',
					'flex flex-col justify-center items-center cursor-pointer transition-colors duration-300',
					className,
					{
						'border-primary border-2': isSelected,
						'border-secondary': !isSelected,
						'opacity-50': isDisabled,
					}
				)}
			>
				<div
					className={classNames(
						'absolute top-2 right-2 w-5 h-5 border-[1px] rounded-full',
						'flex justify-center items-center transition-colors duration-300',
						{
							'border-primary': isSelected,
							'border-secondary': !isSelected,
						}
					)}
				>
					{isSelected && <div className="w-3 h-3 bg-primary rounded-full"></div>}
				</div>

				<div className="flex flex-col items-center">
					<h2
						className={classNames('text-sm font-bold', {
							'text-primary': isSelected,
							'text-secondary': !isSelected,
							'!text-[16px]': !description,
						})}
					>
						{title}
					</h2>
					<p
						className={classNames('text-xs mt-1', {
							'text-primary': isSelected,
							'text-gray-500': !isSelected,
						})}
					>
						{description}
					</p>
				</div>
			</button>
		</div>
	);
};
